// Update body top-padding
import Utils from '../utils/utils'
;(($) => {
    $(() => {
        $(document).ready(() => {
            Utils.updateContentPadding()
        })
    })
})(jQuery)
